import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { resetPage } from '../../redux/slices/containerMovies'
import { resetSeriesPage } from '../../redux/slices/containerSeries'

const SearchBar = (props) => {

    const dispatch = useDispatch()
    const [input, setInput] = useState("")

    const handleChange = (e) => {
        setInput(e.target.value)
    }

    const handleClick = (e) => {
        if (e.target.name === "reset") {
            setInput("")
            dispatch(resetPage())
            dispatch(resetSeriesPage())
            props.onClick(null)
        } else {
            dispatch(resetPage())
            dispatch(resetSeriesPage())
            props.onClick(input)
        }
    }

    return (
        <div className='fl-rw searchbar__container'>
            <div>
                <input placeholder={props.placeholder} onChange={handleChange} type="text" value={input} />
                <button className='button-left' name="reset" onClick={handleClick} value="x">x</button>
            </div>
            <div>
                <button className='button-right' name="buscar" onClick={handleClick} value="Buscar">Buscar</button>
            </div>
        </div>
    )
}

export default SearchBar;